// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconPtsrusde } from "../../../icons/mono/build/icon-ptsrusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const PtsrusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconPtsrusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  PtsrusdeIcon.displayName = 'PtsrusdeIcon';
}

export default PtsrusdeIcon;